export const API_reactions_like = (commentId: string): string =>
  `/api/v1/reactions/comments/${commentId}/like`;
export const API_reactions_like_remove = (commentId: string): string =>
  `/api/v1/reactions/comments/${commentId}/like?remove=true`;
export const API_reactions_point = (_id: string): string => `/api/v1/reactions/points/${_id}`;
export const API_reactions_comment = (commentId: string): string =>
  `/api/v1/reactions/comments/${commentId}`;
export const API_reactions_comments = (): string => '/api/v1/reactions/comments';
